module.exports = __webpack_public_path__ + "img/586A51_CCD5AA_8C9675_8DBBB7-256px.37a699d6.png";